export type IconTone =
  | "blue"
  | "purple"
  | "green"
  | "orange"
  | "red"
  | "yellow"
  | "pink"
  | "indigo"
  | "gray"
  | "amber"
  | "danger";

export const iconToneBg: Record<IconTone, string> = {
  blue: "bg-info-muted",
  purple: "bg-primary-muted",
  green: "bg-success-muted",
  orange: "bg-warning-muted",
  red: "bg-danger-muted",
  yellow: "bg-warning-muted",
  pink: "bg-danger-muted",
  indigo: "bg-primary-muted",
  gray: "bg-gray-100",
  amber: "bg-warning-muted",
  danger: "bg-danger-muted",
};

export const iconToneText: Record<IconTone, string> = {
  blue: "text-info",
  purple: "text-primary",
  green: "text-success",
  orange: "text-danger",
  red: "text-danger",
  yellow: "text-yellow-500",
  pink: "text-danger",
  indigo: "text-primary",
  gray: "text-gray-400",
  amber: "text-warning",
  danger: "text-danger",
};
